module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_sticker_red-4c274b17033efcbe9472b9a9af07cb79.svg";